/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentSkillGrantDto,
  ApiErrorResponse,
  GetApiSkillLibraryParams,
  PatchPlatformSkillRequest,
  PatchTenantSkillRequest,
  PlatformSkillDto,
  TenantSkillDto,
  UpdateAgentSkillGrantsRequest,
  UpsertPlatformSkillRequest,
  UpsertTenantSkillRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiSkillsUrl = () => {




  return `/api/skills`
}

export const getApiSkills = async ( options?: RequestInit): Promise<TenantSkillDto[]> => {

  return orvalControlFetch<TenantSkillDto[]>(getGetApiSkillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiSkillsQueryKey = () => {
    return [
    `/api/skills`
    ] as const;
    }


export const getGetApiSkillsQueryOptions = <TData = Awaited<ReturnType<typeof getApiSkills>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkills>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSkillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSkills>>> = ({ signal }) => getApiSkills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSkills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSkills>>>
export type GetApiSkillsQueryError = unknown


export function useGetApiSkills<TData = Awaited<ReturnType<typeof getApiSkills>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSkills>>,
          TError,
          Awaited<ReturnType<typeof getApiSkills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSkills<TData = Awaited<ReturnType<typeof getApiSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSkills>>,
          TError,
          Awaited<ReturnType<typeof getApiSkills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSkills<TData = Awaited<ReturnType<typeof getApiSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkills>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSkills<TData = Awaited<ReturnType<typeof getApiSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkills>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSkillsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiSkillsUrl = () => {




  return `/api/skills`
}

export const postApiSkills = async (upsertTenantSkillRequest: UpsertTenantSkillRequest, options?: RequestInit): Promise<TenantSkillDto> => {

  return orvalControlFetch<TenantSkillDto>(getPostApiSkillsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertTenantSkillRequest,)
  }
);}




export const getPostApiSkillsMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkills>>, TError,{data: UpsertTenantSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSkills>>, TError,{data: UpsertTenantSkillRequest}, TContext> => {

const mutationKey = ['postApiSkills'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSkills>>, {data: UpsertTenantSkillRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSkills(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSkillsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSkills>>>
    export type PostApiSkillsMutationBody = UpsertTenantSkillRequest
    export type PostApiSkillsMutationError = ApiErrorResponse

    export const usePostApiSkills = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkills>>, TError,{data: UpsertTenantSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSkills>>,
        TError,
        {data: UpsertTenantSkillRequest},
        TContext
      > => {
      return useMutation(getPostApiSkillsMutationOptions(options), queryClient);
    }
    export const getPatchApiSkillsTenantSkillIdUrl = (tenantSkillId: string,) => {




  return `/api/skills/${tenantSkillId}`
}

export const patchApiSkillsTenantSkillId = async (tenantSkillId: string,
    patchTenantSkillRequest: PatchTenantSkillRequest, options?: RequestInit): Promise<TenantSkillDto> => {

  return orvalControlFetch<TenantSkillDto>(getPatchApiSkillsTenantSkillIdUrl(tenantSkillId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchTenantSkillRequest,)
  }
);}




export const getPatchApiSkillsTenantSkillIdMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiSkillsTenantSkillId>>, TError,{tenantSkillId: string;data: PatchTenantSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiSkillsTenantSkillId>>, TError,{tenantSkillId: string;data: PatchTenantSkillRequest}, TContext> => {

const mutationKey = ['patchApiSkillsTenantSkillId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiSkillsTenantSkillId>>, {tenantSkillId: string;data: PatchTenantSkillRequest}> = (props) => {
          const {tenantSkillId,data} = props ?? {};

          return  patchApiSkillsTenantSkillId(tenantSkillId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiSkillsTenantSkillIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiSkillsTenantSkillId>>>
    export type PatchApiSkillsTenantSkillIdMutationBody = PatchTenantSkillRequest
    export type PatchApiSkillsTenantSkillIdMutationError = ApiErrorResponse

    export const usePatchApiSkillsTenantSkillId = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiSkillsTenantSkillId>>, TError,{tenantSkillId: string;data: PatchTenantSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiSkillsTenantSkillId>>,
        TError,
        {tenantSkillId: string;data: PatchTenantSkillRequest},
        TContext
      > => {
      return useMutation(getPatchApiSkillsTenantSkillIdMutationOptions(options), queryClient);
    }
    export const getPostApiSkillsTenantSkillIdUpdateFromLibraryUrl = (tenantSkillId: string,) => {




  return `/api/skills/${tenantSkillId}/update-from-library`
}

export const postApiSkillsTenantSkillIdUpdateFromLibrary = async (tenantSkillId: string, options?: RequestInit): Promise<TenantSkillDto> => {

  return orvalControlFetch<TenantSkillDto>(getPostApiSkillsTenantSkillIdUpdateFromLibraryUrl(tenantSkillId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiSkillsTenantSkillIdUpdateFromLibraryMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkillsTenantSkillIdUpdateFromLibrary>>, TError,{tenantSkillId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSkillsTenantSkillIdUpdateFromLibrary>>, TError,{tenantSkillId: string}, TContext> => {

const mutationKey = ['postApiSkillsTenantSkillIdUpdateFromLibrary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSkillsTenantSkillIdUpdateFromLibrary>>, {tenantSkillId: string}> = (props) => {
          const {tenantSkillId} = props ?? {};

          return  postApiSkillsTenantSkillIdUpdateFromLibrary(tenantSkillId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSkillsTenantSkillIdUpdateFromLibraryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSkillsTenantSkillIdUpdateFromLibrary>>>

    export type PostApiSkillsTenantSkillIdUpdateFromLibraryMutationError = ApiErrorResponse

    export const usePostApiSkillsTenantSkillIdUpdateFromLibrary = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkillsTenantSkillIdUpdateFromLibrary>>, TError,{tenantSkillId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSkillsTenantSkillIdUpdateFromLibrary>>,
        TError,
        {tenantSkillId: string},
        TContext
      > => {
      return useMutation(getPostApiSkillsTenantSkillIdUpdateFromLibraryMutationOptions(options), queryClient);
    }
    export const getGetApiSkillLibraryUrl = (params?: GetApiSkillLibraryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skill-library?${stringifiedParams}` : `/api/skill-library`
}

export const getApiSkillLibrary = async (params?: GetApiSkillLibraryParams, options?: RequestInit): Promise<PlatformSkillDto[]> => {

  return orvalControlFetch<PlatformSkillDto[]>(getGetApiSkillLibraryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiSkillLibraryQueryKey = (params?: GetApiSkillLibraryParams,) => {
    return [
    `/api/skill-library`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSkillLibraryQueryOptions = <TData = Awaited<ReturnType<typeof getApiSkillLibrary>>, TError = ApiErrorResponse>(params?: GetApiSkillLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkillLibrary>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSkillLibraryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSkillLibrary>>> = ({ signal }) => getApiSkillLibrary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSkillLibrary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSkillLibraryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSkillLibrary>>>
export type GetApiSkillLibraryQueryError = ApiErrorResponse


export function useGetApiSkillLibrary<TData = Awaited<ReturnType<typeof getApiSkillLibrary>>, TError = ApiErrorResponse>(
 params: undefined |  GetApiSkillLibraryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkillLibrary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSkillLibrary>>,
          TError,
          Awaited<ReturnType<typeof getApiSkillLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSkillLibrary<TData = Awaited<ReturnType<typeof getApiSkillLibrary>>, TError = ApiErrorResponse>(
 params?: GetApiSkillLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkillLibrary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSkillLibrary>>,
          TError,
          Awaited<ReturnType<typeof getApiSkillLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSkillLibrary<TData = Awaited<ReturnType<typeof getApiSkillLibrary>>, TError = ApiErrorResponse>(
 params?: GetApiSkillLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkillLibrary>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSkillLibrary<TData = Awaited<ReturnType<typeof getApiSkillLibrary>>, TError = ApiErrorResponse>(
 params?: GetApiSkillLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSkillLibrary>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSkillLibraryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiSkillLibraryUrl = () => {




  return `/api/skill-library`
}

export const postApiSkillLibrary = async (upsertPlatformSkillRequest: UpsertPlatformSkillRequest, options?: RequestInit): Promise<PlatformSkillDto> => {

  return orvalControlFetch<PlatformSkillDto>(getPostApiSkillLibraryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPlatformSkillRequest,)
  }
);}




export const getPostApiSkillLibraryMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkillLibrary>>, TError,{data: UpsertPlatformSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSkillLibrary>>, TError,{data: UpsertPlatformSkillRequest}, TContext> => {

const mutationKey = ['postApiSkillLibrary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSkillLibrary>>, {data: UpsertPlatformSkillRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSkillLibrary(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSkillLibraryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSkillLibrary>>>
    export type PostApiSkillLibraryMutationBody = UpsertPlatformSkillRequest
    export type PostApiSkillLibraryMutationError = ApiErrorResponse

    export const usePostApiSkillLibrary = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkillLibrary>>, TError,{data: UpsertPlatformSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSkillLibrary>>,
        TError,
        {data: UpsertPlatformSkillRequest},
        TContext
      > => {
      return useMutation(getPostApiSkillLibraryMutationOptions(options), queryClient);
    }
    export const getPatchApiSkillLibraryPlatformSkillIdUrl = (platformSkillId: string,) => {




  return `/api/skill-library/${platformSkillId}`
}

export const patchApiSkillLibraryPlatformSkillId = async (platformSkillId: string,
    patchPlatformSkillRequest: PatchPlatformSkillRequest, options?: RequestInit): Promise<PlatformSkillDto> => {

  return orvalControlFetch<PlatformSkillDto>(getPatchApiSkillLibraryPlatformSkillIdUrl(platformSkillId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchPlatformSkillRequest,)
  }
);}




export const getPatchApiSkillLibraryPlatformSkillIdMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiSkillLibraryPlatformSkillId>>, TError,{platformSkillId: string;data: PatchPlatformSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiSkillLibraryPlatformSkillId>>, TError,{platformSkillId: string;data: PatchPlatformSkillRequest}, TContext> => {

const mutationKey = ['patchApiSkillLibraryPlatformSkillId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiSkillLibraryPlatformSkillId>>, {platformSkillId: string;data: PatchPlatformSkillRequest}> = (props) => {
          const {platformSkillId,data} = props ?? {};

          return  patchApiSkillLibraryPlatformSkillId(platformSkillId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiSkillLibraryPlatformSkillIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiSkillLibraryPlatformSkillId>>>
    export type PatchApiSkillLibraryPlatformSkillIdMutationBody = PatchPlatformSkillRequest
    export type PatchApiSkillLibraryPlatformSkillIdMutationError = ApiErrorResponse

    export const usePatchApiSkillLibraryPlatformSkillId = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiSkillLibraryPlatformSkillId>>, TError,{platformSkillId: string;data: PatchPlatformSkillRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiSkillLibraryPlatformSkillId>>,
        TError,
        {platformSkillId: string;data: PatchPlatformSkillRequest},
        TContext
      > => {
      return useMutation(getPatchApiSkillLibraryPlatformSkillIdMutationOptions(options), queryClient);
    }
    export const getPostApiSkillLibraryPlatformSkillIdInstallUrl = (platformSkillId: string,) => {




  return `/api/skill-library/${platformSkillId}/install`
}

export const postApiSkillLibraryPlatformSkillIdInstall = async (platformSkillId: string, options?: RequestInit): Promise<TenantSkillDto> => {

  return orvalControlFetch<TenantSkillDto>(getPostApiSkillLibraryPlatformSkillIdInstallUrl(platformSkillId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiSkillLibraryPlatformSkillIdInstallMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkillLibraryPlatformSkillIdInstall>>, TError,{platformSkillId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSkillLibraryPlatformSkillIdInstall>>, TError,{platformSkillId: string}, TContext> => {

const mutationKey = ['postApiSkillLibraryPlatformSkillIdInstall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSkillLibraryPlatformSkillIdInstall>>, {platformSkillId: string}> = (props) => {
          const {platformSkillId} = props ?? {};

          return  postApiSkillLibraryPlatformSkillIdInstall(platformSkillId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSkillLibraryPlatformSkillIdInstallMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSkillLibraryPlatformSkillIdInstall>>>

    export type PostApiSkillLibraryPlatformSkillIdInstallMutationError = ApiErrorResponse

    export const usePostApiSkillLibraryPlatformSkillIdInstall = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSkillLibraryPlatformSkillIdInstall>>, TError,{platformSkillId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSkillLibraryPlatformSkillIdInstall>>,
        TError,
        {platformSkillId: string},
        TContext
      > => {
      return useMutation(getPostApiSkillLibraryPlatformSkillIdInstallMutationOptions(options), queryClient);
    }
    export const getGetApiAgentsAgentIdSkillsUrl = (agentId: string,) => {




  return `/api/agents/${agentId}/skills`
}

export const getApiAgentsAgentIdSkills = async (agentId: string, options?: RequestInit): Promise<AgentSkillGrantDto[]> => {

  return orvalControlFetch<AgentSkillGrantDto[]>(getGetApiAgentsAgentIdSkillsUrl(agentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAgentsAgentIdSkillsQueryKey = (agentId: string,) => {
    return [
    `/api/agents/${agentId}/skills`
    ] as const;
    }


export const getGetApiAgentsAgentIdSkillsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError = unknown>(agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAgentsAgentIdSkillsQueryKey(agentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>> = ({ signal }) => getApiAgentsAgentIdSkills(agentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(agentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAgentsAgentIdSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>>
export type GetApiAgentsAgentIdSkillsQueryError = unknown


export function useGetApiAgentsAgentIdSkills<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError = unknown>(
 agentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>,
          TError,
          Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgentsAgentIdSkills<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError = unknown>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>,
          TError,
          Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgentsAgentIdSkills<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError = unknown>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAgentsAgentIdSkills<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError = unknown>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdSkills>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAgentsAgentIdSkillsQueryOptions(agentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPutApiAgentsAgentIdSkillsUrl = (agentId: string,) => {




  return `/api/agents/${agentId}/skills`
}

export const putApiAgentsAgentIdSkills = async (agentId: string,
    updateAgentSkillGrantsRequest: UpdateAgentSkillGrantsRequest, options?: RequestInit): Promise<AgentSkillGrantDto[]> => {

  return orvalControlFetch<AgentSkillGrantDto[]>(getPutApiAgentsAgentIdSkillsUrl(agentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAgentSkillGrantsRequest,)
  }
);}




export const getPutApiAgentsAgentIdSkillsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAgentsAgentIdSkills>>, TError,{agentId: string;data: UpdateAgentSkillGrantsRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiAgentsAgentIdSkills>>, TError,{agentId: string;data: UpdateAgentSkillGrantsRequest}, TContext> => {

const mutationKey = ['putApiAgentsAgentIdSkills'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAgentsAgentIdSkills>>, {agentId: string;data: UpdateAgentSkillGrantsRequest}> = (props) => {
          const {agentId,data} = props ?? {};

          return  putApiAgentsAgentIdSkills(agentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiAgentsAgentIdSkillsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAgentsAgentIdSkills>>>
    export type PutApiAgentsAgentIdSkillsMutationBody = UpdateAgentSkillGrantsRequest
    export type PutApiAgentsAgentIdSkillsMutationError = unknown

    export const usePutApiAgentsAgentIdSkills = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAgentsAgentIdSkills>>, TError,{agentId: string;data: UpdateAgentSkillGrantsRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiAgentsAgentIdSkills>>,
        TError,
        {agentId: string;data: UpdateAgentSkillGrantsRequest},
        TContext
      > => {
      return useMutation(getPutApiAgentsAgentIdSkillsMutationOptions(options), queryClient);
    }
